import React, { useContext } from 'react'
import { SearchContext } from '../../context/context.jsx'
import SortByDropdown from '../SortByDropdown/SortByDropdown.jsx'
import { SET_PAGE, SET_PER_PAGE } from '../../actions/actionTypes';


export default function Pagination({ type }) {
  const [context, dispatch] = useContext(SearchContext)
  const { page, per_page, sortBy, dataMeta, searchTerm } = context


  const prevPage = () => {
    if ( page > 1 ) {
      dispatch({
        type: SET_PAGE,
        payload: {
          value: (parseFloat(page) - 1)
        },
      })
    }
  };

  const nextPage = () => {
      if ( page < parseFloat(dataMeta.last_page) ) {
        dispatch({
          type: SET_PAGE,
          payload: {
            value: (parseFloat(page) + 1)
          },
        })
      }
  };

  const onPerPageChange = (e) => {
    dispatch({
      type: SET_PER_PAGE,
      payload: {
        value: e.target.value
      },
    })
  }

  const prevBtnClass =  page === 1 ? 'is-disabled' : '';
  const nextBtnClass = page + 1 > dataMeta.last_page ? 'is-disabled' : '';

  return (
    <div className={`c-searchPagination c-searchPagination--${type}`}>
      <div className="c-searchPagination__body d-flex align-items-center justify-content-between">

        <SortByDropdown sortByValue={sortBy} dispatch={dispatch} searchTerm={searchTerm} />

        <div className="h-pagination d-flex align-items-center">

          <div className="h-pagination__pagerWrapper d-flex align-items-center">
            <label className="h-pagination__label mb-0 mr-3 text-nowrap">Results per page</label>
            <select className="h-pagination__dropdown h-dropdown form-control" value={per_page} onChange={onPerPageChange}>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="30">30</option>
              <option value="50">50</option>
            </select>
          </div>

          <div className="h-pagination__buttonsWrapper d-flex align-items-center">
            <div className={`c-searchPagination__paginationButton c-searchPagination__paginationButton--prev  h-pagination__button ${prevBtnClass}`} onClick={prevPage}>
              <i className="icon ion-ios-arrow-back"></i>
            </div>
          <label><span class="c-searchPagination__label">Page</span> <span className="c-searchPagination__currentPage">{ page }</span> of <span className="c-searchPagination__lastPage">{ dataMeta.last_page}</span></label>
            <div className={`c-searchPagination__paginationButton c-searchPagination__paginationButton--next h-pagination__button ${nextBtnClass}`} onClick={nextPage}>
              <i className="icon ion-ios-arrow-forward"></i>
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}